import { getAuthState } from "../../assets/scripts/login-util";
import { axiosPost, axiosGet, axiosDelete } from "./axiosFunctions";

const getMatMasterAllUrl                = '/api/admin/mat/getMatMasterAll';
const getCoachTaggingAllUrl             = '/api/admin/mat/getCoachTaggingAll';
const getRangeTypeAllUrl                = '/api/admin/mat/getRangeTypeAll';
const postMatMasterUrl                  = '/api/admin/mat/postMatMaster';
const postCoachTaggingUrl               = '/api/admin/mat/postCoachTagging';
const postRangeTypeUrl                  = '/api/admin/mat/postRangeType';

const getMatTimeMasterAllUrl            = '/api/admin/mat/getMatTimeMasterAll';
const postMatTimeMasterUrl              = '/api/admin/mat/postMatTimeMaster';

const postMatTemplateUrl                = '/api/admin/mat/postMatTemplate';
const getMatTemplateByMasterIDUrl       = (id) => `/api/admin/mat/getMatTemplateByMasterID/${id}`;
const getMatGuestBookingByDateUrl       = (guestID, selectedDate) => `/api/admin/mat/getMatGuestBookingByDateUrl/${guestID}/${selectedDate}`;
const deleteMatTemplateUrl              = '/api/admin/mat/deleteMatTemplate';

const getMatBookUrl                     = '/api/admin/mat/getMatBook';
const postMatTimeBlockUrl               = '/api/admin/mat/postMatTimeBlock';  
const postMatBookUrl                    = '/api/admin/mat/postMatBook';  
const updateMatCancelUrl                = '/api/admin/mat/updateMatCancel';  
const deleteMatTimeBlockUrl             = (id) => `/api/admin/mat/deleteMatTimeBlock/${id}`;  
const deleteMatBookUrl                  = (bookingID, comment) => `/api/admin/mat/deleteMatBook/${bookingID}/${comment}`;
const getMatCancellationSheetUrl        = (fDate, tDate) => `/api/admin/mat/getMatCancellationSheet/${fDate}/${tDate}`;
const getMatBookSheetUrl                = (fDate, tDate) => `/api/admin/mat/getMatBookSheet/${fDate}/${tDate}`;

const getMatPublishPageDataUrl          = '/api/admin/mat/getMatPublishPageData';    
const postMatPublishUrl                 = '/api/admin/mat/postMatPublish';    
const getPublishMasterDataUrl           = '/api/admin/mat/getPublishMasterData';    
const getViewMatBookByDateUrl           = (fDate, tDate) => `/api/admin/mat/getViewMatBookByDate/${fDate}/${tDate}`;
const getRangeFeeCalendarAllUrl         = '/api/admin/mat/getRangeFeeCalendarAll';
const postRangeFeeCalendarUrl           = '/api/admin/mat/postRangeFeeCalendar';
const postRangeFeeMasterUrl             = '/api/admin/mat/postRangeFeeMaster';
const getRangeFeeMasterByCalenderIDUrl  = (calendarId) => `/api/admin/mat/getRangeFeeMasterByCalenderID/${calendarId}`;
const getRangeFeeMasterByDateUrl        = (date) => `/api/admin/mat/getRangeFeeMasterByDate/${date}`;
 

export const deleteMatBook = async (bookingID, comment) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet(
        deleteMatBookUrl(bookingID, comment),
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getMatCancellationSheet = async (fDate, tDate) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
  
    const response = await axiosGet(
        getMatCancellationSheetUrl(fDate, tDate),
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getMatBookSheet = async (fDate, tDate) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
  
    const response = await axiosGet(
        getMatBookSheetUrl(fDate, tDate),
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getMatMasterAll = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatMasterAllUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getCoachTaggingAll = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getCoachTaggingAllUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getRangeTypeAll = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getRangeTypeAllUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postMatMaster= async(matMaster)=>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatMasterUrl, { matMaster }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postCoachTagging= async(coachTagging)=>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postCoachTaggingUrl, { coachTagging }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postRangeType= async(matMaster)=>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postRangeTypeUrl, { matMaster }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getMatTimeMasterAll = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatTimeMasterAllUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postTimeMatMaster= async(matMaster)=>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatTimeMasterUrl, { matMaster }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postMatTemplate= async(matTemplate)=>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatTemplateUrl, { matTemplate }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const deleteMatTemplate = async(templateId) => {
    const token = getAuthState('token');
    if(!token) setTimeout(() => { return }, 2000);

    const response = await axiosDelete( `${deleteMatTemplateUrl}/${templateId}`, { headers: { auth_token: `bearer ${token}` } });
    return response;
}

export const getMatTemplateByMasterID = async(id) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatTemplateByMasterIDUrl(id), { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getMatBook = async (matBookDetails) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( getMatBookUrl, {matBookDetails}, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getMatGuestBookingByDate = async (guestID, selectedDate) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet(getMatGuestBookingByDateUrl(guestID, selectedDate), { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postMatTimeBlock = async(books, date) =>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatTimeBlockUrl, { books, date }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const deleteMatTimeBlock = async (id) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosDelete(
        deleteMatTimeBlockUrl(id),
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const postMatBook = async(matBook)=>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatBookUrl, { matBook }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const updateMatCancel = async(matDetails)=>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( updateMatCancelUrl, { matDetails }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getMatPublishPageData = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatPublishPageDataUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postMatPublish = async(data) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatPublishUrl, {...data }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getPublishMasterData = async(masterId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( `${getPublishMasterDataUrl}/${masterId}`, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}
 
export const getViewMatBookByDate = async (fDate, tDate) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
  
    const response = await axiosGet(
        getViewMatBookByDateUrl(fDate, tDate),
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getRangeFeeCalendarAll = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getRangeFeeCalendarAllUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}
  
export const postRangeFeeCalendar = async(rangeCalendar) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postRangeFeeCalendarUrl, { rangeCalendar }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}
 
export const postRangeFeeMaster = async (rateList) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost(
        postRangeFeeMasterUrl,
      { rateList },
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getRangeFeeMasterByCalenderID = async (calendarId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getRangeFeeMasterByCalenderIDUrl(calendarId), { headers: { auth_token: `bearer ${token}` } } );
    return response;
};

export const getRangeFeeMasterByDate = async (date) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getRangeFeeMasterByDateUrl(date), { headers: { auth_token: `bearer ${token}` } } );
    return response;
};
